import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './UserContext';
import { DataProvider } from './DataContext';

// One-time auth migration (B4.5): the JWT now lives in an httpOnly cookie, never
// in localStorage. Purge any legacy `authToken` a returning user still has stored
// BEFORE React renders or any fetch fires — otherwise the data-fetch components
// (which still read this key) would send a stale `Bearer <old token>` and
// authenticate as the OLD user for some requests while the cookie governs the
// rest (split-brain). Nothing writes this key anymore, so purging once is final.
localStorage.removeItem('authToken');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	// <React.StrictMode>
	<UserProvider>
		<DataProvider>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</DataProvider>
	</UserProvider>

	// </React.StrictMode>
);

reportWebVitals();
